import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit, AfterContentInit, Input } from '@angular/core';
import { CreativesCoxV5Component } from '../creatives-cox-v5/creatives-cox-v5.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { EVENT_EMITTERS, FILE_MEDIA_TYPES, PATHS } from '../../../analytics/constants/analytics.constants';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import * as _ from 'underscore';
import * as jQuery from 'jquery';
import * as numeral from 'numeral';
import { unescapeLeadingUnderscores } from 'typescript';

interface IMediaFile {
	type: string;
	url: string;
	width: number;
	height: number;
}

@Component({
	selector: 'app-preroll-creative-r5',
	templateUrl: './preroll-creative-r5.component.html',
	styleUrls: ['./preroll-creative-r5.component.css']
})
export class PrerollCreativeR5Component extends CreativesCoxV5Component implements OnInit, AfterViewInit {
	public R5_videoId: any;
	public displayData: any;
	setDisplayProperties: any;
	@ViewChild('videoName') videoplayer: any;
	public isPaused: boolean;
	public isMuted = false;
	public selectedVideoSubscription: any;
	public blackIcons = false;
	public isPreroll: boolean;
	public pageSpecificClass: string;
	public isR9: boolean;
	primaryColor: string;
	defaultColor: string;
	@Input() sortdataby: any;
	@Input() sectionclass: string;
	@Input() columnsconfig: any;
	@Input() placeholderimage: any;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected modalService: ModalService
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.selectedIndex = 0;
			this.cdr.detectChanges();
			this.requestData();
		});
	}

	ngAfterViewChecked() {
		jQuery('.carouselSlide.current').click();
		if (this.isAudioCreative) {
			jQuery('.streamingAudioSvg path').css({
				fill: this.primaryColor
			});
			if (!UtilityService.isUndefinedOrNull(jQuery('#preRollvideo')[0])) {
				jQuery('#preRollvideo')[0].autoplay = false;
			}
		}
	}

	ngOnInit() {
		this.columns =
			this.columnsconfig && typeof this.columnsconfig === 'string'
				? JSON.parse(decodeURI(this.columnsconfig))
				: this.columnsconfig
				? this.columnsconfig
				: [];
		super.ngOnInit();
		this.primaryColor = this.colorPalette.primaryColor;
		this.defaultColor = this.isR11 ? '#90a8c3' : 'white';
		this.options.startSlide = 0;
		this.legend = _.filter(this.legend, (item) => {
			return this.analyticsDataModel.checkComponentForPermission(item);
		});
		this.isPreroll = this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL;
		this.pageSpecificClass = this.analyticsDataModel.getCurrentPath() + '_PAGE_SPECIFIC';
		this.isR9 = this.analyticsDataModel.config.version === 'R9' ? true : false;
	}
	requestData() {
		this.showLoad = true;
		this.hasData = true;
		this.analyticsService.processWidgetRequest(this.key, this.columns).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.responseData = response.data;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	openModal(id: string) {
		this.modalService.open(id);
	}

	closeModal(id: string) {
		this.modalService.close(id);
	}
	isActiveSlide(index) {
		return this.selectedIndex == index;
	}

	getMp4FromMediaFilesJson(mediaFilesJson: string) {
		let mp4Link: string = null;

		let decodedMediaFiles: Array<IMediaFile>;
		let isJsonDecodeSuccess = false;
		try {
			decodedMediaFiles = JSON.parse(mediaFilesJson);
			isJsonDecodeSuccess = true;
		} catch (e) {
			isJsonDecodeSuccess = false;
		}

		if (isJsonDecodeSuccess && decodedMediaFiles) {
			let fallBackMediaFile: IMediaFile;
			for (const mediaFile of decodedMediaFiles) {
				if (mediaFile.type === FILE_MEDIA_TYPES.MP4) {
					if (mediaFile.width === 640 && mediaFile.height === 360) {
						mp4Link = mediaFile.url;
						break;
					} else {
						if (fallBackMediaFile) {
							if (fallBackMediaFile.width > mediaFile.width && mediaFile.width >= 640) {
								fallBackMediaFile = mediaFile;
							}
						} else {
							fallBackMediaFile = mediaFile;
						}
					}
				}
			}

			if ((mp4Link === null || mp4Link === '') && fallBackMediaFile) {
				mp4Link = fallBackMediaFile.url;
			}
		}

		return mp4Link;
	}

	processResponseData(responseData) {
		if (responseData.length > 0) {
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
			this.sortedCreatives =
				this.sortdataby && !(this.sortdataby === 'undefined')
					? this.sortCreativesBySelection(this.sortdataby)
					: this.creatives;
			this.sortedCreatives.map((creative) => {
				creative.creativeVideo = creative.isNonManagedVideo ? creative.creativeVideo : this.getMp4FromMediaFilesJson(creative.creativeVideo);
			});
			const videoCreatives = _.where(this.sortedCreatives, { isVideoCreative: true });
			this.isVideoCreative = videoCreatives.length > 0;
			const audioCreatives = _.where(this.sortedCreatives, { isAudioCreative: true });
			this.isAudioCreative = audioCreatives.length > 0;
			const selectedLegend: any = _.findWhere(this.legend, { selected: true });
			this.blackIcons = this.isAudioCreative ? true : false;
		} else {
			this.hasData = false;
		}
	}

	getPercentageClass(percentage) {
		return `p${Math.floor(percentage)}`;
	}
	getPercentage(percentage) {
		return { width: `${Math.floor(percentage)}%` };
	}

	ngAfterViewInit() {
		this.cdr.detectChanges();
	}
	circleVideoClickEvent(typeOfPercent) {
		if (this.videoplayer.nativeElement.currentSrc != null) {
			const gettheVideoTotalDuration = this.videoplayer.nativeElement.duration;
			const gettheEqualDuration = parseFloat(gettheVideoTotalDuration) / 4;
			let getStartTime;
			let getEndTime;
			let calcDuration;
			if (typeOfPercent == 0) {
				jQuery('#preRollvideo')[0].currentTime = 0;
				jQuery('#preRollvideo')[0].play();
				getStartTime = 0;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = gettheEqualDuration - getStartTime;
				calcDuration = calcDuration * 1000;
			} else if (typeOfPercent == 25) {
				jQuery('#preRollvideo')[0].currentTime = gettheEqualDuration;
				jQuery('#preRollvideo')[0].play();
				getStartTime = 0;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = gettheEqualDuration - getStartTime;
				calcDuration = calcDuration * 1000;
			} else if (typeOfPercent == 50) {
				jQuery('#preRollvideo')[0].currentTime = gettheEqualDuration + gettheEqualDuration;
				jQuery('#preRollvideo')[0].play();
				getStartTime = gettheEqualDuration;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = getEndTime - getStartTime;
				calcDuration = calcDuration * 1000;
			} else if (typeOfPercent == 75) {
				jQuery('#preRollvideo')[0].currentTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				jQuery('#preRollvideo')[0].play();
				getStartTime = gettheEqualDuration + gettheEqualDuration;
				getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
				calcDuration = getEndTime - getStartTime;
				calcDuration = calcDuration * 1000;
			} else if (typeOfPercent == 100) {
				const getCurrentTime = jQuery('#preRollvideo')[0].currentTime;
				const totDuration = jQuery('#preRollvideo')[0].duration;
				if (getCurrentTime < totDuration) {
					jQuery('#preRollvideo')[0].currentTime = gettheVideoTotalDuration - 1;
					jQuery('#preRollvideo')[0].play();
					getStartTime = gettheEqualDuration + gettheEqualDuration;
					getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
					calcDuration = getEndTime - getStartTime;
					calcDuration = calcDuration * 1000;
				}
				if (getCurrentTime >= totDuration) {
					jQuery('#preRollvideo')[0].currentTime = 0;
					jQuery('#preRollvideo')[0].play();
					getStartTime = gettheEqualDuration + gettheEqualDuration;
					getEndTime = gettheEqualDuration + gettheEqualDuration + gettheEqualDuration + gettheEqualDuration;
					calcDuration = getEndTime - getStartTime;
					calcDuration = calcDuration * 1000;
				}
			}
		}
	}

	slideClicked(index) {
		this.selectedIndex = index;
		this.cdr.detectChanges();
		this.isMuted = true;
		if (!UtilityService.isUndefinedOrNull(jQuery('#preRollvideo')[0])) {
			jQuery('#preRollvideo')[0].muted = true;
			if (this.isAudioCreative) {
				jQuery('#pauseBtn').hide();
			}
		}
		this.controlsOptions(this.primaryColor, this.defaultColor);
		this.carousel.slideClicked(index);
		for (let slide in this.carousel.$slides) {
			this.carousel.$slides[slide].className = 'carouselSlide';
		}
		this.carousel.$slides[index].className = 'carouselSlideActive';
		jQuery('.carouselSlideActive .slide-3d .slideMask').css({
			width: '0px',
			height: '0px'
		});
		jQuery(' .carouselSlideActive .slide-3d').css({
			'margin-top': '0% !important'
		});
		jQuery(' .carouselSlide .slide-3d').css({
			'margin-top': '0% !important'
		});
		jQuery('.carouselSlide .slide-3d .slideMask').css({
			width: '100%',
			height: '100%'
		});
		jQuery('.carouselSlide .volumeControls').css({
			visibility: 'hidden !important'
		});

		jQuery('.stats-div').css({
			width: '100%',
			height: '100%'
		});

		this.selectedIndex = index;
		this.currentCreativeData = JSON.parse(JSON.stringify(this.sortedCreatives[this.selectedIndex]));
		this.R5_videoId = this.selectedIndex;
		const pickedData = _.pick(this.sortedCreatives[this.selectedIndex], this.displayStats);
		let keys = [];
		this.currentStats = _.map(this.legend, (legend, index) => {
			if (pickedData[legend['value']]) {
				let hasPercent = legend['value'].slice(0, -1) + 'Rate' in pickedData;
				let percent_value = hasPercent
					? numeral(pickedData[legend['value'].slice(0, -1) + 'Rate']).format('0,0.00') + '%'
					: '';
				return {
					name: legend['displayName'],
					value: Number(pickedData[legend['value']]),
					hasPercent: hasPercent,
					percent_value: percent_value
				};
			} else {
				return {
					name: legend['displayName'],
					value: ''
				};
			}
		});
		for (let key in pickedData) {
			if (key.toLowerCase().includes('rate')) {
				this.currentCreativeData[key] = numeral(this.currentCreativeData[key]).format('0,0.00') + '%';
			} else {
				this.currentCreativeData[key] = this.currentCreativeData[key].toLocaleString();
			}
			if (key.startsWith('avg')) {
				keys.push({
					name: 'Avg. ' + key.charAt(3).toUpperCase() + key.substr(4, key.length) + '',
					value: this.currentCreativeData[key]
				});
			} else {
				keys.push({ name: key.replace(/([A-Z])/g, ' $1').trim(), value: this.currentCreativeData[key] });
			}
		}
		this.currentCreativeStats = keys;
	}

	controlsOptions(primaryColor?, defaultColor?) {
		const media = document.getElementById('preRollvideo');
		let gettheVideoTotalDuration;
		let checkfor0Percentage;
		let checkfor25Percentage;
		let checkfor50Percentage;
		let checkfor75Percentage;
		let checkfor100Percentage;
		const isPlaying = function (e) {
			gettheVideoTotalDuration = jQuery('#preRollvideo')[0].duration;
			checkfor0Percentage = 0 / 4;
			checkfor25Percentage = gettheVideoTotalDuration / 4;
			checkfor50Percentage = parseFloat(checkfor25Percentage) * 2;
			checkfor75Percentage = parseFloat(checkfor25Percentage) * 3;
			checkfor100Percentage = parseFloat(checkfor25Percentage) * 4;
			jQuery('#pauseBtn').show();
			jQuery('#playBtn').hide();
		};
		const onPause = function (e) {
			jQuery('#pauseBtn').hide();
			jQuery('#playBtn').show();
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime === gettheVideoTotalDuration) {
				jQuery('#svg_0Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_25Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: primaryColor, color: primaryColor });
			}
		};
		const onTimeUpdate = function (e) {
			jQuery('#svg_0Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			jQuery('#svg_25Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			jQuery('#svg_0Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 1.0 });
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor25Percentage) {
				jQuery('#svg_25Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 0.1 });
				if (defaultColor === 'white') {
					jQuery('#svg_25Percent').animate(
						{ opacity: 1.0 },
						{
							duration: checkfor25Percentage * 1000,
							easing: 'linear'
						}
					);
				} else if (defaultColor === '#90a8c3') {
					jQuery('#svg_25Percent').css({ opacity: 1 });
				}
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor25Percentage) {
				jQuery('#svg_25Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor50Percentage) {
				jQuery('#svg_50Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 0.1 });
				if (defaultColor === 'white') {
					jQuery('#svg_50Percent').animate(
						{ opacity: 1.0 },
						{
							duration: checkfor25Percentage * 1000,
							easing: 'linear'
						}
					);
				} else if (defaultColor === '#90a8c3') {
					jQuery('#svg_50Percent').css({ opacity: 1 });
				}
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor50Percentage) {
				jQuery('#svg_50Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor75Percentage) {
				jQuery('#svg_75Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 1.0 });
				jQuery('#svg_75Percent').animate(
					{ opacity: 1.0 },
					{
						duration: checkfor25Percentage * 1000,
						easing: 'linear'
					}
				);
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor75Percentage) {
				jQuery('#svg_75Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor100Percentage) {
				jQuery('#svg_100Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 1.0 });
				jQuery('#svg_100Percent').animate(
					{ opacity: 1.0 },
					{
						duration: checkfor25Percentage * 1000,
						easing: 'linear'
					}
				);
				jQuery('#playBtn').show();
				jQuery('#pauseBtn').hide();
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor100Percentage) {
				jQuery('#svg_100Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			}
		};
		if (media) {
			media.addEventListener('playing', isPlaying, false);
			media.addEventListener('pause', onPause, false);
			media.addEventListener('timeupdate', onTimeUpdate, false);
		}
	}

	playclickEvent(event) {
		event.stopPropagation();
		jQuery('#playBtn').hide();
		jQuery('#pauseBtn').show();
		jQuery(this.videoplayer.nativeElement)[0].play();
	}

	pauseclickEvent(event) {
		event.stopPropagation();
		jQuery('#playBtn').show();
		jQuery('#pauseBtn').hide();
		jQuery(this.videoplayer.nativeElement)[0].pause();
	}

	volumeclick(event) {
		event.stopPropagation();
		this.isMuted = true;
		jQuery('#preRollvideo')[0].muted = true;
	}

	muteclick(event) {
		event.stopPropagation();
		this.isMuted = false;
		jQuery('#preRollvideo')[0].muted = false;
	}

	ngAfterContentChecked() {
		jQuery('.inline' + this.displayStats.length).css('width', 100 / this.displayStats.length + '%');
		jQuery('.stats-div').css({
			width: '100%',
			height: '100%'
		});
		jQuery('.carousel-3d').css({
			width: '30%',
			height: '300px'
		});
		jQuery('.carousel-3d-container').css({
			height: '90%',
			top: '10%',
			margin: '4% auto'
		});
		jQuery('.slide-3d').css({
			'border-color': 'rgba(0, 0, 0, 0.5)',
			'border-width': '1px',
			'border-style': 'none'
		});
	}
}
